import BaseEntity from '../database/BaseEntity.js';

/**
 * Video Entity
 * Represents a Video in the system
 *
 * Built-in fields (auto-generated):
 * - id: Unique identifier
 * - createdAt: Creation timestamp
 * - updatedAt: Last update timestamp
 * - createdBy: Email of user who created the record
 */
class Video extends BaseEntity {
  static collectionName = 'videos';
  static _schema = JSON.parse("{\"name\":\"Video\",\"type\":\"object\",\"properties\":{\"titulo\":{\"type\":\"string\",\"description\":\"Título del video\"},\"url_video\":{\"type\":\"string\",\"description\":\"URL del video (YouTube embed, mp4, etc.)\"},\"descripcion\":{\"type\":\"string\",\"description\":\"Descripción del video\"},\"categoria\":{\"type\":\"string\",\"enum\":[\"Música\",\"Conciertos\",\"Videoclips\",\"Entrevistas\",\"Variedad\"],\"default\":\"Música\",\"description\":\"Categoría del video\"},\"miniatura\":{\"type\":\"string\",\"description\":\"URL de la miniatura del video\"},\"artista\":{\"type\":\"string\",\"description\":\"Nombre del artista o grupo\"},\"duracion\":{\"type\":\"string\",\"description\":\"Duración del video (ej: 3:45)\"},\"activo\":{\"type\":\"boolean\",\"default\":true,\"description\":\"Si el video está activo\"},\"orden\":{\"type\":\"number\",\"description\":\"Orden de aparición\"}},\"required\":[\"titulo\",\"url_video\"]}");
}

export { Video };
export default Video;
